import { itineraryMapElementId, getRootElement } from './root';

/** @type {Record<string, string | undefined>} */
const currencyCodeByLocalization = {
  UK: 'GBP',
  AU: 'AUD',
  CA: 'CAD',
  CN: 'CAD',
  US: 'USD',
};

export const mapTypes = /** @type {const} */ ({
  world: 'world',
  itinerary: 'itinerary',
});

/**
 * @param {string} [id]
 */
function getMapType(id) {
  if (id === itineraryMapElementId) {
    return mapTypes.itinerary;
  }

  return mapTypes.world;
}

function createConfig() {
  const root = getRootElement();
  const localization = root?.dataset?.localization?.toUpperCase() ?? 'US';
  return {
    apiBaseUrl: root?.dataset?.apiBaseUrl ?? '/',
    mapId: root?.dataset?.mapId ?? '',
    mapsApiKey: root?.dataset?.mapsApiKey ?? '',
    mapType: getMapType(root?.id),
    office: root?.dataset?.office?.toUpperCase() ?? 'US',
    localization,
    currencyCode: currencyCodeByLocalization[localization] ?? /** @type {string} */ (currencyCodeByLocalization.US),
    disableDrawerDrag: root?.dataset?.disableDrawerDrag != null,
    initializeBounds: root?.dataset?.initializeBounds != null,
    applicationName: root?.dataset?.applicationName ?? '',
  };
}

export const config = createConfig();
